<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    :options="data.form"
                    :validations="validations.tipoStatusId"
                    label="Tipo"
                    show-default-option
                    text-field="nome"
                    v-model="model.tipoStatusId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    :validations="validations.nomeStatus"
                    label="Nome"
                    v-model="model.nomeStatus"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Mixins.
import { repository, error, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'


export default {
    computed: {
        validations() {

            return {
                nomeStatus: { required: true, min: 3, max: 100 },
                tipoStatusId: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('manutencao.parametrizacao')
        }

        if (this.status) {

            this.loadStatus();
        }
    },
    data: () => ({
        model: {
            id: null,
            nomeStatus: null,
            tipoStatusId: null,
            tipoStatusNome: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        loadStatus() {

            Object.assign(this.model, this.status)
        },
        save() {
            this.$refs.Form.validate()
                .then(valid => {
                    if (!valid) return;

                    if (!this.status) {

                        const statusDuplicado = this.statusJaAdicionado();
                        const nomeDuplicado = this.nomeStatusJaAdicionado();

                        if (statusDuplicado && nomeDuplicado) {

                            this.showValidationNotification('O tipo de status selecionado e o nome já foram incluídos.');
                            return;
                        } else if (statusDuplicado) {

                            this.showValidationNotification('O tipo de status selecionado já foi incluído.');
                            return;
                        } else if (nomeDuplicado) {

                            this.showValidationNotification('O nome do status já foi incluído.');
                            return;
                        }
                    }

                    if (this.status) {

                        Object.assign(this.originalStatus, this.prepareData());
                    } else {

                        this.data.model.status.push(this.prepareData());
                    }

                    this.$emit('save');
                });
        },
        statusJaAdicionado() {

            return !!this.data.model.status.find(r => r.tipoStatusId === this.model.tipoStatusId)
        },
        nomeStatusJaAdicionado() {

            return !!this.data.model.status.find(r => r.nomeStatus === this.model.nomeStatus)
        },
        prepareData() {

            const data = this.clone(this.model)

            data.tipoStatusNome = this.data.form.find(t => t.id === data.tipoStatusId).nome

            return data
        }
    },
    mixins: [repository, error, object],
    props: {
        data: { type: Object, required: true },
        originalStatus: { type: Object },
        status: { type: Object },
    },
}
</script>